var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden"},attrs:{"id":"app"}},[_c('router-view'),(_vm.isTablet)?_c('div',{staticClass:"landscape_warning"},[_c('img',{attrs:{"src":require("./assets/images/rotate_notice.png")}}),_c('p',{staticClass:"rotate_text"},[_vm._v("请旋转至横屏")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }